import React, { useMemo } from "react";
import InputMask from "react-input-mask";
import MaterialTextField, { StandardTextFieldProps } from "@material-ui/core/TextField";
import FormField from "@modules/formx-react/FormField";
import { formatDotsToCommas, toNumberFormat } from "./utils";

export type TextProps = {
  name: string;
  mask?: string;
  label?: string;
  helperText?: string;
  maxLength?: number;
  allowMax?: boolean;
  lengthCountFunc?: (v: string) => number;
  onChange?: (e) => void;
  TextFieldProps?: Partial<StandardTextFieldProps>;
  beforeChange?: (v: string) => string;
  disabled?: boolean;
  type?: "text" | "number";
};

export const Text: React.FC<TextProps> = (props) => {
  const { TextFieldProps: textFieldProps, type = "text" } = props;
  const isTypeNumber = type === "number";

  const renderHelperText = (field) => {
    return (
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <span>{props.helperText}</span>
        <span>
          {props.maxLength ? countLength(field.value) + "/" + props.maxLength : ""}
        </span>
      </div>
    );
  };

  const countLength = useMemo(
    () => props.lengthCountFunc || ((v) => v.length),
    [props.lengthCountFunc]
  );

  return (
    <FormField
      name={props.name}
      fieldOptions={{
        transformValue: isTypeNumber ? toNumberFormat : undefined,
        parseValue: isTypeNumber ? formatDotsToCommas : undefined
      }}
    >
      {(field) => {
        // `TextFieldProps` is spread before the explicit `disabled` prop below, so a
        // `disabled` passed through it would otherwise be overridden and silently ignored.
        const disabled = props.disabled || field.disabled || textFieldProps?.disabled;

        const textField = (
          <MaterialTextField
            {...field.fieldProps}
            onChange={(e) => {
              const shouldChange =
                props.allowMax ||
                !props.maxLength ||
                props.maxLength >= countLength(e.target.value);
              if (shouldChange) {
                props.onChange && props.onChange(e);
                field.fieldProps.onChange(e);
              }
            }}
            label={field.error || props.label}
            error={field.invalid && !field.disabled}
            value={field.value || ""}
            fullWidth
            helperText={props.maxLength ? renderHelperText(field) : props.helperText}
            {...textFieldProps}
            inputProps={{
              "data-error": field.invalid ? field.error : undefined,
              ...textFieldProps?.inputProps
            }}
            disabled={disabled}
          />
        );

        if (props.mask) {
          return (
            <InputMask
              mask={props.mask}
              {...field.fieldProps}
              disabled={disabled}
              value={field.value || ""}
              onChange={(e) => {
                console.log("onchange", e);
                console.log(e.target.value);
                e.target.value = props.beforeChange?.(e.target.value) ?? e.target.value;
                field.fieldProps.onChange(e);
              }}
            >
              {() => (
                <MaterialTextField
                  label={field.error || props.label}
                  error={field.invalid && !field.disabled}
                  disabled={disabled}
                  fullWidth
                  helperText={
                    props.maxLength ? renderHelperText(field) : props.helperText
                  }
                  inputProps={{
                    "data-error": field.invalid ? field.error : undefined,
                    ...textFieldProps?.inputProps
                  }}
                />
              )}
            </InputMask>
          );
        }

        return textField as any;
      }}
    </FormField>
  );
};

export default Text;
